import {
  ActionList,
  ActionListItem,
  ArrowRightIcon,
  Box,
  Button,
  Dropdown,
  DropdownOverlay,
  SelectInput,
  Text,
} from '@razorpay/blade/components';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';
import PageLayout from 'components/ui/Layout/PageLayout';
import { StepHeader } from 'components/WizardViews/components';
import useFeatures from 'hooks/useFeatures';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { bulkActions } from './constants';

const BulkActions = () => {
  const { features } = useFeatures();
  const permissions = useSelector(loggedInUserSelectors.permissions);
  const disabledFeatures = useIsFeatureDisabledForRearch();
  const history = useHistory();

  const internalActions = Object.entries(bulkActions).filter(([, action]) => {
    if (
      action.rearchFeatures &&
      action.rearchFeatures.some((feature) => disabledFeatures?.[feature])
    ) {
      return false;
    } else if (action.feature && !Boolean(features?.[action.feature])) {
      return false;
    } else if (
      action.permissions &&
      !action.permissions.every((permission) => permissions.includes(permission))
    ) {
      return false;
    }
    return true;
  });

  const [selectedOption, setSelectedOption] = React.useState<string>('');

  const handleSubmit = () => {
    history.push(bulkActions[selectedOption as keyof typeof bulkActions].href);
  };

  return (
    <PageLayout
      hideHeading
      withoutBackgroundImg
      boxProps={{
        marginX: 'spacing.4',
        marginY: 'spacing.7',
        width: 'initial',
      }}
      containerProps={{
        width: '100%',
        maxWidth: '600px',
        marginX: 'auto',
      }}
      withIllustration>
      <StepHeader title="Bulk" subtitle="Actions" />
      <Text color="surface.text.gray.muted" marginTop="spacing.3">
        Select the action you want to do for multiple employees
      </Text>
      <Box
        marginTop="spacing.7"
        borderWidth="thin"
        borderColor="surface.border.gray.muted"
        borderRadius="medium"
        padding={'spacing.7'}>
        <Dropdown>
          <SelectInput
            value={selectedOption}
            label="Select bulk action"
            placeholder="Select bulk action"
            onChange={(e) => setSelectedOption(e.values[0])}
          />
          <DropdownOverlay>
            <ActionList>
              {internalActions.map(([key, action]) => (
                <ActionListItem
                  key={key}
                  title={action.label}
                  value={key}
                  description={action.description}
                />
              ))}
            </ActionList>
          </DropdownOverlay>
        </Dropdown>
      </Box>
      <Button
        marginTop="spacing.9"
        icon={ArrowRightIcon}
        iconPosition="right"
        onClick={handleSubmit}>
        Next
      </Button>
    </PageLayout>
  );
};

export { BulkActions };
